export default "__VITE_ASSET__uG3qqaaA__"